import { getAllStoreVoucherAction } from "../../redux/toolkit/vouchers/getAllStoreVoucher";
import React, { useEffect, useState } from "react";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";
import DoneIcon from "@mui/icons-material/Done";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SearchIcon from "@mui/icons-material/Search";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Breadcrumbs,
  Button,
  Card,
  IconButton,
  Link,
  Paper,
  TextField,
  Typography,
  MenuItem,
  Menu,
  Tooltip,
} from "@mui/material";
import { Box, maxWidth, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { dateFormatStartFun } from "../../helper/dateConverter";
import Body from "../../layout/Body";
import { useStyles } from "../../theme/theme";
import AreYouSureDailogUi from "../../comman/AreYouSureDailogUi";
import { updateStoreVoucherActivationAction } from "../../redux/toolkit/vouchers/updateStoreVoucherStatus";

let user_id = null;

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/allStoreVoucher"
      >
        Store Voucher
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Store Voucher
    </Typography>
  </Stack>
);

const AllStoreVoucher = () => {
  const dispatch = useDispatch();
  const allVoucherData = useSelector((state) => state.allStoreVoucher);
  let { data, loading, total } = allVoucherData;
  const [open, setOpen] = useState(false);
  const [store, setStore] = useState({});
  const storeResponse = useSelector((state) => state.storeVoucherActivation);
  const navigate = useNavigate()
  const { status, message } = storeResponse;

  const [snack, setSnack] = useState(false);
  const classes = useStyles();
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      maxWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          // (page * pageSize) + params?.api?.getRowIndex(params.row._id) + 1;
          page * pageSize + params.api.getRowIndex(params.id) + 1;
        return serialNumber;
      },

      // renderCell: (params) => {
      //   const { page, pageSize } = pageState;
      //   const serialNumber = (page * pageSize) +
      //     params?.api?.getRowIndex(params.row._id) + 1
      //   return serialNumber;
      // }
    },

    {
      field: "product_sku",
      headerName: "Product Sku Id",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?.sku}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?.name}</Typography>
          </LinkRRD>
        );
      },
    },

    // {
    //   field: "image",
    //   headerName: "Image",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 300,
    //   renderCell: (params) => {
    //     const imageUrl = params?.row?.image;
    //     return (
    //       //   <LinkRRD >
    //       <img
    //         src={imageUrl}
    //         alt="Thumbnail"
    //         style={{
    //           width: 60,
    //           height: 60,
    //           objectFit: "cover",
    //           borderRadius: 6,
    //         }}
    //       />
    //     );
    //   },
    // },

    {
      field: "updated_at",
      headerName: "updated_at",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD>
            <Typography color="primary">{params?.row?.updated_at ? moment(params?.row?.updated_at).local().format("YYYY-MM-DD hh:mm::ss A") : "---"}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "how_to_use_points",
      headerName: "How To Use Points",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 350,
      renderCell: (params) => {
        const points = params?.row?.how_to_use_points || [];
        return (
          <Box>
            {points.map((item, index) => (
              <Tooltip
                title={item}
                sx={{
                  maxWidth: "300px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <Typography key={index} variant="body2" color="primary">
                  • {item}
                </Typography>
              </Tooltip>

            ))}
          </Box>
        );
      },
    },

    {
      field: "price",
      headerName: "Price",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      maxWidth: 400,
      renderCell: (params) => {
        return (
          <>
            <Stack>
              {params?.row?.price?.denominations?.map((price, idx) => {
                return (
                  <Typography key={params.row._id + "_" + idx}>
                    {price}
                  </Typography>
                );
              })}
            </Stack>
          </>
        );
      },
    },

    {
      field: "is_active",
      headerName: "Is Active",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {

              setStore(params?.row);
              setOpen(true);
              navigate("/")
            }}
          >
            {params?.row?.is_active ? "activated" : "deactivated"}
          </Button>
        );
      },
    },
    {
      field: "editing",
      headerName: "Edit",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              navigate(`/edit/voucher/${params?.row?._id}`)
            }}
          >
            Edit
          </Button>
        );
      },
    },
  ];

  const handleToggel = () => {
    console.log("adding voucher in store");
    setOpen(false);
    dispatch(updateStoreVoucherActivationAction(store?._id));
    setSnack(true);
    setTimeout(() => {
      window.location.reload();   // ✅ Refresh page
    }, 1000);

  };



  useEffect(() => {
    dispatch(getAllStoreVoucherAction({ page: pageState.page, limit: pageState.pageSize }));
  }, [dispatch, pageState?.page, pageState?.pageSize]);

  return (
    <>
      <Helmet>
        <title>All Store</title>
      </Helmet>

      <Appbar breadcrumb={breadcrumb} />

      <Body>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        ></Stack>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={adminColumns}
              getRowId={(row) => row.sku}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>
      </Body>

      {/* {open && (
         <AreYouSureDailogUi
           message={`Are You Sure YOU Want To make This Voucher`,store.is_active ? 'activated' : 'deactivated'}
           state={open}
           setState={setOpen}
           handleClick={handleToggel}
         />
       )} */}

      {open && (
        <AreYouSureDailogUi
          message={`Are you sure you want to make this voucher ${store?.is_active ? "deactivated" : "activated"
            }?`}
          state={open}
          setState={setOpen}
          handleClick={handleToggel}
        />
      )}

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default AllStoreVoucher;
